export const REDUCER_NAME = "match";
export const SET_ERROR = `${REDUCER_NAME}/SET_ERROR`;
export const SET_MATCH = `${REDUCER_NAME}/SET_MATCH`;
export const RESET_MATCH = `${REDUCER_NAME}/RESET_MATCH`;

export const STATUS_POSTPONED = "POSTPONED";
export const STATUS_CANCELLED = "CANCELLED";
